<template>
    <div>
        <div class="col-sm-12">
            <div class="ibox">
                <div class="ibox-title" style="border: none;">
                    <el-form id="elForm" :inline="true" :model="formInline" ref="formInline" label-width="120px" label-position="right" class="demo-form-inline" size="medium">
                      <el-form-item label="督导标准名称：" prop="scorePolicyName">
                        <el-input v-model="formInline.scorePolicyName" placeholder="请输入督导标准名称"></el-input>
                      </el-form-item>
                      <el-form-item label="学年：" prop="yearName">
                          <el-input v-model="formInline.yearName" :maxlength="4" placeholder="请输入学年" v-on:blur="changeYear"></el-input>
                      </el-form-item>
                      <el-form-item>
                          <el-button class="btn-hhs" @click="query()">查询</el-button>
                          <!--<el-button class="btn-primary" @click="getList(formInline)">查询</el-button>
                          <el-button class="btn-default" @click="onReset('formInline')">重置</el-button>-->
                      </el-form-item>
                    </el-form>
                    <!--<div style="padding: 20px 0;border-top: 1px solid #ddd;">注意：每月测评一次，次月第一天，出上月的测评结果</div>-->
                    <el-table ref="multipleTable" id="tableList" class="table-bordered" :data="tableData" element-loading-text="拼命加载中" bordertooltip-effect="dark" style="width: 100%">
                        <el-table-column prop="scorePolicyName" label="督导标准名称"></el-table-column>
                        <el-table-column prop="yearName" label="学年" width="100"></el-table-column>
                        <el-table-column prop="startMonth" label="开始月份" show-overflow-tooltip width="100"></el-table-column>
                        <el-table-column prop="endMonth" label="结束月份" show-overflow-tooltip width="100"> </el-table-column>
                        <el-table-column prop="scoreArea" label="评测区域" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="itemNum" label="评测内容数量" show-overflow-tooltip width="150"></el-table-column>
                        <el-table-column prop="totalScore" label="满分" show-overflow-tooltip width="100"></el-table-column>
                        <el-table-column label="操作" width='100'>
                          <template slot-scope="scope">
                            <!-- <span @click="orgmgrDel(scope.$index,scope.row)" style='cursor: pointer;'>详情</span> -->
                             <span v-for='(item,index) in listArea' :key='index' style='cursor: pointer;' @click="doClick(item.operFunc,scope.$index,scope.row)" >{{item.operName}}</span>
                          </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 25, 50, 100]" :page-size="formInline.pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total" style="margin-top: 10px;">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--彈出的添加-->
      <el-dialog title="" :visible.sync="dialogTableVisible" :showClose="false" width="70%" min-width="500px" :before-close="handleClose" :close-on-click-modal='false'>
        <router-view v-on:close="close" v-if='dialogTable===true'></router-view>
      </el-dialog>
  </div>
</template>
<script>
import {MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import common from '../../com/common'
export default {
  name: '',
  data () {
    return {
      dialogTableVisible: false,
      dialogTable: false,
      tableData: [], // 数据表数据
      formInline: {// 筛选条件表单数据
        scorePolicyName: '',
        yearName: ''
      },
      currentPage: 1,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      generalArea:[],
      listArea:[]
    }
  },
  created () {
    var that = this
    if(this.$route.query.did) {
      this.$router.push({path: '/supervisorDetail/' + this.$route.query.did})
    }
    api.post(config.host + 'org/getOrgDetailWithDefault.do').then(function (json) {
      var defaultCountry = json.body.defaultCountry
      var orgInfo = json.body.orgInfo
      if (defaultCountry !== undefined) {
        that.formInline.cityID = defaultCountry.parentID
        that.formInline.countryID = defaultCountry.id
      } else {
        that.formInline.cityID = orgInfo.cityID
        that.formInline.countryID = orgInfo.countryID
      }
      that.formInline.provinceID = orgInfo.provinceID
      that.getList(that.formInline)
    })
  },
  mounted(){
    let btnList = window.paramFromParent
    console.log(btnList)
    btnList = common.getBtnList(btnList)
    this.generalArea = btnList.generalArea
    this.listArea = btnList.listArea
  },
  methods: {
    handleClose () {
      let that = this
      that.dialogTableVisible = false
      that.dialogTable = false
    },
    close (flag, refresh) {
      this.dialogTableVisible = flag
      if (refresh === true) {
        this.getList(this.formInline)
      }
    },
    orgmgrDel (index, row) { // 详情
      this.dialogTableVisible = true
      this.$router.push({path: 'supervisorDetail/' + row.id})
      console.log(row.id)
      this.dialogTable = true
    },
    showMsgTip (value, type) { // 提示消息
      if (type === 'false') {
        this.$message({
          message: value
        })
      } else {
        this.$message({
          message: value,
          type: type
        })
      }
    },
    handleSizeChange (val) { // 分页每页条数改变事件
      this.formInline.pageSize = val
      this.getList(this.formInline)
    },
    handleCurrentChange (val) { // 分页页数改变事件
      this.formInline.pageNum = val
      this.getList(this.formInline)
    },
    query() {
      this.currentPage=this.formInline.pageNum=1
      this.getList(this.formInline)
    },
    getList (pram) { // 获取表格数据
      var that = this

      api.post(config.khsHost + 'spv/policy/hhs/getScorePolicyList.do', pram).then(function (response) {
        if (response.success === true) {
          that.tableData = response.body.list
        }
        that.total = that.tableData.length
      })
    },
    changeYear () {
      var num = this.formInline.yearName
      var reg = /\d/
      if (!reg.test(num)) {
        this.formInline.yearName = ''
      } else if (isNaN(num) === true) {
        this.formInline.yearName = ''
      }
    },
    doClick(operFunc,index,row){
      switch(operFunc){
       case 'showDetail':this.orgmgrDel(index,row);break
      }
    }
  }
}
</script>

<style scoped>
.ml15 {
    margin-left: 15px;
}
#tableList .el-table .cell, .el-table th>div{
    padding-left: 0;
    padding-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/supervisor/supervisor.vue